import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import {
  authCardBodySx,
  authCardHeaderIconSx,
  authCardHeaderSx,
  authCardSx,
  authCardWideSx,
  authPageSx,
} from "./authStyles";

const AuthFormLayout = ({
  title,
  subtitle,
  icon: Icon,
  wide = false,
  maxWidth,
  children,
  footer,
}) => {
  const cardSx = maxWidth
    ? { ...(wide ? authCardWideSx : authCardSx), maxWidth }
    : wide
      ? authCardWideSx
      : authCardSx;

  return (
    <Box component="main" sx={authPageSx}>
      <Box sx={cardSx}>
        <Box sx={authCardHeaderSx}>
          <Stack direction="row" spacing={2} alignItems="center">
            {Icon ? (
              <Box sx={authCardHeaderIconSx}>
                <Icon sx={{ fontSize: { xs: 26, sm: 30 } }} />
              </Box>
            ) : null}
            <Box>
              <Typography
                component="h1"
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: "1.375rem", sm: "1.625rem" },
                  letterSpacing: "0.02em",
                  lineHeight: 1.15,
                }}
              >
                {title}
              </Typography>
              {subtitle ? (
                <Typography
                  sx={{
                    mt: 0.5,
                    fontSize: "0.9375rem",
                    opacity: 0.9,
                    lineHeight: 1.5,
                    maxWidth: 420,
                  }}
                >
                  {subtitle}
                </Typography>
              ) : null}
            </Box>
          </Stack>
        </Box>
        <Box sx={authCardBodySx}>
          {children}
          {footer}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthFormLayout;
